// extracted by mini-css-extract-plugin
export default {"card":"Guid_card__gM4Xu","main":"Guid_main__j38eA","more_button":"Guid_more_button__apZjH"};